module.exports = ["SFProText-Regular","SFProText-Medium","SFProDisplay-Regular","MabryPro-Black","MabryPro-Bold"]


//////////////////
// WEBPACK FOOTER
// ./src/fonts.json
// module id = 0znu
// module chunks = 1